import React from "react";
import "../styles.css";

const Lessons = () => {
  return (
    <div className="page-container">
      <h1>Lessons</h1>

      <p className="contact">
        Need to reach us?{" "}
        <a href="mailto:info@xfiremusic.com.au" aria-label="Email Xfire Music">
          info@xfiremusic.com.au
        </a>
      </p>

      <img src="https://gigabout.com.au/artistposts/1781236110166-xfirelessons.jpg" alt="Xfire Lessons" className="logo"/>
      <h2>Available Lessons</h2>
      <ul className="lesson-list">
        <li>Drums</li>
        <li>Electric Guitar</li>
        <li>Bass Guitar</li>
        <li>Acoustic Guitar</li>
        <li>Vocals</li>
        <li>Sound Engineering</li>
      </ul>

      <p>
        <strong>Rates:</strong> $40 per half-hour session (Booking essential).
      </p>
      <p>
        <strong>Group sessions available.</strong>
      </p>
    </div>
  );
};

export default Lessons;
